import React, { Component } from 'react';
import { NotificationManager } from 'react-notifications';

import {
  FormGroup,
  Card,
  CardHeader,
  Form,
  Label,
  Input,
  Button,
  Container,
  Row,
  Col,
} from 'reactstrap';

import Header from 'components/Headers/Header.js';
import TaxServiceCategoryService from './TaxServiceCategoryService';

export default class EditTaxServiceCategory extends Component {
  state = {
    category: '',
    description: '',
    status: true,
    errors: {},
    loading: false,
    fetching: true,
  };

  componentDidMount() {
    const { slug } = this.props.match.params;
    TaxServiceCategoryService.getCategoryBySlug(slug)
      .then((res) => {
        const { category, description, status } = res.data;
        this.setState({ category, description, status, fetching: false });
      })
      .catch(() => {
        NotificationManager.error('Category not found.', 'Error', 3000);
        this.props.history.push('/admin/tax-service/categories');
      });
  }

  onChangeInput = (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { slug } = this.props.match.params;
    const { category, description, status } = this.state;

    this.setState({ loading: true, errors: {} });
    TaxServiceCategoryService.updateCategory(slug, { category, description, status })
      .then(() => {
        NotificationManager.success('Tax service category updated!', 'Success!', 2000);
        this.props.history.push('/admin/tax-service/categories');
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || 'Failed to update category.';
        NotificationManager.error(msg, 'Error', 3000);
        this.setState({ loading: false });
      });
  };

  render() {
    const { category, description, status, errors, loading, fetching } = this.state;

    if (fetching) {
      return (
        <>
          <Header />
          <Container className="mt--7" fluid>
            <p className="text-white">Loading...</p>
          </Container>
        </>
      );
    }

    return (
      <>
        <Header />
        <Container className="mt--7" fluid>
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <h3 className="mb-0">Edit Tax Service Category</h3>
                </CardHeader>
                <Form onSubmit={this.handleSubmit}>
                  <FormGroup>
                    <Col sm={12}>
                      <Label for="category">Category Name</Label>
                      <Input
                        type="text"
                        name="category"
                        id="category"
                        value={category}
                        onChange={this.onChangeInput}
                        required
                        minLength={3}
                        maxLength={350}
                      />
                      {errors.category && <small className="text-danger">{errors.category}</small>}
                    </Col>
                  </FormGroup>
                  <FormGroup>
                    <Col sm={12}>
                      <Label for="description">Description</Label>
                      <Input
                        type="textarea"
                        name="description"
                        id="description"
                        value={description}
                        onChange={this.onChangeInput}
                        required
                        minLength={3}
                        maxLength={1000}
                        rows={4}
                      />
                      {errors.description && (
                        <small className="text-danger">{errors.description}</small>
                      )}
                    </Col>
                  </FormGroup>
                  <FormGroup>
                    <Col sm={12}>
                      <Label check>
                        <Input
                          type="checkbox"
                          name="status"
                          checked={status}
                          onChange={this.onChangeInput}
                        />{' '}
                        Active
                      </Label>
                    </Col>
                  </FormGroup>
                  <FormGroup>
                    <Col sm={12}>
                      <Button type="submit" className="btn btn-primary mr-2" disabled={loading}>
                        {loading ? 'Saving...' : 'Update'}
                      </Button>
                      <Button
                        type="button"
                        color="secondary"
                        onClick={() => this.props.history.push('/admin/tax-service/categories')}
                      >
                        Cancel
                      </Button>
                    </Col>
                  </FormGroup>
                </Form>
              </Card>
            </div>
          </Row>
        </Container>
      </>
    );
  }
}
